<template>
  <div class="pa-7" id="function">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
    <v-row>
      <v-col cols="12">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
         <v-card-title class="descriptiontitle">
         <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1"
        large>
        mdi-magnify
        </v-icon>
              {{ descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary">
                {{ description }}
              </v-card-text>
              <v-card-title class="descriptiontitle">
                       <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1"
        large>
        mdi-magnify
        </v-icon>{{ descriptiontitle2 }}
              </v-card-title>
              <v-card-text class="summary">
                {{ description2 }}
              </v-card-text>
              <v-card-text class="summary1">
                {{ description3 }}
              </v-card-text>
            </div>
          </div>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
  color:#345fb5;
  border-bottom:2px solid;
  margin-bottom:0.7rem;
}
.summary1{
  margin-top:-1rem;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '機能',
      // タイトル横のアイコン
      icon: 'mdi-cog-outline',
      // 説明タイトル
      descriptiontitle: 'アクセスコントロール',
      // 説明文
      description: 'ドキュメントに検索レベルを設けることで、権限に応じたドキュメントが検索できます。',
      // 説明タイトル2
      descriptiontitle2: '追跡管理',
      // 説明文2
      description2: 'ドキュメントのダウンロード、検索キーワード等記録することができます。',
      // 説明文3
      description3: '※ 非同期で転置インデックスを作成しますので、複数個所から同時にドキュメントがアップされた場合でも、サーバーのスペックに合わせて同時処理数を制限することができます。※ LDAP対応も可能です。'
    }
  }
}
</script>
